export const LOADING_DETAILS_AND_POLICY =
  "Loading hotel details and cancellation policy";

export const CANCELLATION_IN_PROGRESS = "Your cancellation is being processed";
export const DO_NOT_EXIT =
  "Please do not exit until the cancellation is complete.";
